// import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { colors, fonts } from '../../utils';

const { red, colorInput } = colors;

const { primaryFont } = fonts;

const menuItemStyle = { fontSize: '1.4rem' };

// const useStyles = makeStyles((theme) => ({
// 	menuPaper: {
// 		maxHeight: '30rem !important',
// 		fontSize: '1.2rem',
// 		fontFamily: primaryFont,
// 		fontWeight: 600,
// 	},
// }));

const errorText = {
	color: red,
	fontSize: '1.2rem',
	fontFamily: primaryFont,
	fontWeight: '600',
};

const FilledSelectOption = ({
	label,
	state,
	onChange,
	options,
	width,
	minWidth,
	maxWidth,
	name,
	error,
	errorMsg,
	onFocus,
	onBlur,
	required,
	disabled,
	lockOption,
	initalStateNotShow,
}) => {
	// const classes = useStyles();
	return (
		<div>
			<FormControl
				variant='filled'
				sx={{
					width: width || '100%',
					minWidth: minWidth || '16rem',
					maxWidth: maxWidth || '18rem',
				}}>
				<InputLabel id={state}>{label}</InputLabel>
				<Select
					labelId={state}
					id={state}
					value={state}
					onChange={(e) => onChange(e)}
					error={error}
					style={{
						fontSize: '1.2rem',
						fontFamily: primaryFont,
						// padding: '0.1rem',
					}}
					onFocus={onFocus}
					onBlur={onBlur}
					name={name}
					required={required}
					disabled={disabled}
					sx={{
						'& .MuiInputBase-input': {
							fontWeight: '600 !important',
							fontFamily: primaryFont,
							// width: '100%',
							// minWidth: '14rem',
							padding: '2.5rem 1.3rem 0.5rem',
							backgroundColor: colorInput,
						},
						'& .Mui-Select-select:focus': {
							backgroundColor: 'none',
						},
					}}
					MenuProps={{
						// classes: { paper: classes.menuPaper },
						sx: {
							maxHeight: '30rem !important',
							fontSize: '1.2rem',
							fontFamily: 'primaryFont', // Replace with your actual font if needed
							fontWeight: 600,
							'& .MuiList-root': {
								display: 'flex ',
								flexFlow: 'column ',
								// alignItems: 'flex-start',
								// margin: '0.5rem 1rem',
								// gap: '1rem',
								width: '100%',
							},
							'& .Mui-selected': {
								width: '100%',
								padding: '1.5rem 1.5rem',
							},
							'& .MuiMenuItem-root': {
								padding: '1.5rem 1.5rem',
								fontSize: '1.2rem',
								fontFamily: primaryFont,
								fontWeight: 500,
							},
							'& .MuiMenuItem-root:hover': {
								width: '100%',
							},
							'& .MuiButtonBase-root': {
								display: 'flex',
								justifyContent: 'flex-start',
							},
						},
					}}>
					{!initalStateNotShow && (
						<MenuItem value='' style={menuItemStyle}>
							<em>None</em>
						</MenuItem>
					)}
					{options &&
						options?.length > 0 &&
						options?.map((data) => {
							return (
								<MenuItem
									value={data?.id?.toString() || data?.employeeId?.toString()}
									key={data?.id || data?.employeeId}
									style={menuItemStyle}>
									{data?.description || data?.employeeName}
								</MenuItem>
							);
						})}
					{lockOption &&
						lockOption?.length &&
						lockOption?.map((data) => {
							return (
								<MenuItem value={data?.id} key={data?.id} style={menuItemStyle}>
									{/* {data?.id} - {data?.description}  */}
									{data?.description}
								</MenuItem>
							);
						})}
				</Select>
				{errorMsg && <FormHelperText style={errorText}>{errorMsg}</FormHelperText>}
			</FormControl>
		</div>
	);
};

export default FilledSelectOption;
